import { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import Context from "../../Context";

const CardHisto1 = () => {
  const { histoClinica, setHistoClinica, showIcons } = useContext(Context);
  
  

  // TEXT AREA motivo de consulta
  const [motivo, setMotivo] = useState(histoClinica.motivoConsulta);

  

  const handleMotivoConsulta = (event) => {

    const inputMotivo = event.target.value;

    setMotivo(inputMotivo);

    histoClinica.motivoConsulta = inputMotivo;

    localStorage.setItem("localMotivo", JSON.stringify(inputMotivo));

  };

  // TEXT AREA diagnostico medico
 

  const [diagnostico, setDiagnostico] = useState(histoClinica.diagnosticoMedico);

  const handleDiagnostico = (event) => {

    const inputDiagnostico = event.target.value;

    setDiagnostico(inputDiagnostico);

    histoClinica.diagnosticoMedico = inputDiagnostico;

    localStorage.setItem("localDiagnostico", JSON.stringify(inputDiagnostico));

  };
  // TEXT AREA estudios diagnosticos
  const [estudiosDiagnosticos, setEstudiosDiagnosticos] = useState(histoClinica.estudiosDiagnosticos);

  const handleEstudiosDiagnosticos = (event) => {

    const inputEstudiosDiagnosticos = event.target.value;
    setEstudiosDiagnosticos(inputEstudiosDiagnosticos);
    histoClinica.diagnosticoMedico = inputEstudiosDiagnosticos;

    localStorage.setItem("localEstudiosDiagnosticos", JSON.stringify(inputEstudiosDiagnosticos));

  };
  // TEXT AREA medicacion
  const [medicacion, setMedicacion] = useState(histoClinica.medicacion);

  const handleMedicacion = (event) => {

    const inputMedicacion = event.target.value;
    setMedicacion(inputMedicacion);
    histoClinica.medicacion = inputMedicacion;

    localStorage.setItem("localMedicacion", JSON.stringify(inputMedicacion));
  };

  const handleDeleteForm = ()=>{
    setMotivo('')
    setDiagnostico('')
    setEstudiosDiagnosticos('')
    setMedicacion('') 
    localStorage.removeItem("localMotivo" ,"localDiagnostico","localEstudiosDiagnosticos","localMedicacion" );
    
    
  }

  return (
    <>
      <div className="column">
        <div className="card-section">
          <div style={{ /*  width: 400, */ margin: 20 }}>
            <h4 className="text-center">Anamnesis 1.1</h4>
            <br />
            <h6>Motivo de consulta</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={ motivo }
              onChange={ handleMotivoConsulta }
            />

            <h6 className="mt-2">Diagnóstico médico</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={diagnostico}
              onChange={handleDiagnostico}
            />

            <h6 className="mt-2">Estudios diagnósticos</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={estudiosDiagnosticos}
              onChange={handleEstudiosDiagnosticos}
            />

            <h6 className="mt-2">Medicación</h6>
            <Form.Control
              as="textarea"
              placeholder="Escriba aquí..."
              value={medicacion}
              onChange={handleMedicacion}
            />
          </div>
        </div>
        { showIcons &&   <div className="icons-card-canvas mb-5">
          <img
            className="icon-trash-canvas"
            src="/assets/images/trash.png"
            alt="icon-image"
            onClick={ handleDeleteForm }
          />
          {/* <img
            className="icon-trash-canvas"
            src="/assets/images/icon-download.png"
            alt="icon-image"
            onClick={() => alert("Imagen guardada")}
          /> */}
        </div>}
      </div>
    </>
  );
};

export default CardHisto1;
